import gameNames from '../../hub/data/GameIds';

import { ONBOARDING_PHASES } from '../data/constants';

export const initialState = {
  areDropzonesDefined: false,
  dropzones: {
    onset: {},
    rime: {},
  },
  dropzonesTemp: {
    onset: {},
    rime: {},
  },
  draggableBotNumber: null,
  draggableBotType: null,
  onboardingBotNumber: null,
  onboardingPhase: null,
};

const dragdropReducer = (state = initialState, action) => {
  if (action.gameId !== gameNames.WORDBOTS) {
    return state;
  }

  switch (action.type) {
    case 'WORDBOTS_INIT_DROPZONE_LAYOUT': {
      const { dropzoneKey, layout } = action.payload;

      const dropzonesTemp = {
        ...state.dropzonesTemp,
      };
      dropzonesTemp[dropzoneKey] = layout;

      const areDropzonesDefined = !!dropzonesTemp.onset.w && !!dropzonesTemp.rime.w;

      return {
        ...state,
        areDropzonesDefined,
        dropzones: areDropzonesDefined ? dropzonesTemp : state.dropzones,
        dropzonesTemp,
      };
    }
    case 'WORDBOTS_RESET_DRAGDROP_STATE': {
      return {
        ...initialState,
      };
    }
    case 'WORDBOTS_SELECT_DRAGGABLE_BOT': {
      const { draggableBotNumber, draggableBotType } = action.payload;

      return {
        ...state,
        draggableBotNumber,
        draggableBotType,
      };
    }
    case 'WORDBOTS_DESELECT_DRAGGABLE_BOT': {
      return {
        ...state,
        draggableBotNumber: null,
        draggableBotType: null,
      };
    }
    case 'WORDBOTS_SET_ONBOARDING_PHASE': {
      const { onboardingBotNumber, onboardingPhase } = action.payload;

      return {
        ...state,
        onboardingBotNumber,
        onboardingPhase,
      };
    }
    case 'WORDBOTS_RESET_ONBOARDING_PHASE': {
      return {
        ...state,
        onboardingBotNumber: state.onboardingPhase === ONBOARDING_PHASES.INTRO ? null : state.onboardingBotNumber,
        onboardingPhase: null,
        draggableBotNumber: null,
        draggableBotType: null,
      };
    }
    default:
      return state;
  }
};

export default dragdropReducer;
